"use client";

import React from "react";
import { Maximize2 } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const portfolioItems = [{
  id: 1,
  title: "Side Return Extension",
  location: "North West London",
  image: "https://solidtrustbuilder.com/wp-content/uploads/2026/03/WhatsApp-Image-2026-03-19-at-11.00.24.jpeg?v=g0k1st5rgx",
  ratio: 4 / 3
}, {
  id: 2,
  title: "Luxury Kitchen Build",
  location: "North West London",
  image: "https://solidtrustbuilder.com/wp-content/uploads/2026/04/WS202511-04-1-scaled.jpg?v=fyk9owjjb9",
  ratio: 3 / 4
}, {
  id: 3,
  title: "House Refurbishment",
  location: "North West London",
  image: "https://solidtrustbuilder.com/wp-content/uploads/2026/04/WS202511-01-scaled.jpg?v=9flwubfstp",
  ratio: 16 / 9
}, {
  id: 4,
  title: "Dormer Loft Conversion",
  location: "North West London",
  image: "https://solidtrustbuilder.com/wp-content/uploads/2026/04/35e74a5d-106a-4b1a-842a-207bec353dbc.png?v=9uthlw47zi8",
  ratio: 1 / 1
}, {
  id: 5,
  title: "Double Storey Extension",
  location: "North West London",
  image: "https://solidtrustbuilder.com/wp-content/uploads/2026/04/WS202511-08-scaled.jpg?v=twgg9npraoq",
  ratio: 3 / 4
}, {
  id: 6,
  title: "Attic Conversion",
  location: "North West London",
  image: "https://solidtrustbuilder.com/wp-content/uploads/2026/03/WhatsApp-Image-2026-03-19-at-11.00.21.jpeg?v=zj1vo5nl6ae",
  ratio: 4 / 3
}];
export default function ThePortfolio() {
  return <section id="the-portfolio" className="dark bg-background text-foreground py-24 px-6 md:px-12 border-y border-border">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-8 border-b border-border pb-8">
          <div>
            <h2 className="text-4xl md:text-6xl font-bold uppercase tracking-tighter mb-4">
              Our Craft
            </h2>
            <p className="text-muted-foreground max-w-xl font-mono text-sm uppercase tracking-widest leading-relaxed">
              A visual journey through our finest house extensions and loft
              conversions in North West London.
            </p>
          </div>
          <div className="hidden md:block">
            <div className="w-24 h-2 bg-foreground"></div>
          </div>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {portfolioItems.map((item, i) => <div data-index={i} key={item.id} className="break-inside-avoid">
              <Dialog>
                <DialogTrigger asChild>
                  <div className="group relative overflow-hidden cursor-pointer border-2 border-border bg-muted">
                    <AspectRatio ratio={item.ratio}>
                      <img src={item.image} alt={item.title} className="object-cover w-full h-full grayscale transition-transform duration-700 ease-in-out group-hover:scale-105" />
                      <div className="absolute inset-0 bg-background/80 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-between p-6">
                        <div className="flex justify-end">
                          <div className="bg-foreground text-background p-2 rounded-none">
                            <Maximize2 className="w-5 h-5" />
                          </div>
                        </div>
                        <div className="border-l-4 border-foreground pl-4">
                          <h3 className="text-xl md:text-2xl font-bold uppercase tracking-tight text-foreground mb-2">
                            {item.title}
                          </h3>
                          <p className="font-mono text-xs text-muted-foreground uppercase tracking-widest">
                            {item.location}
                          </p>
                        </div>
                      </div>
                    </AspectRatio>
                  </div>
                </DialogTrigger>
                <DialogContent className="max-w-5xl p-0 bg-background border-2 border-border rounded-none overflow-hidden">
                  <DialogHeader className="sr-only">
                    <DialogTitle>{item.title}</DialogTitle>
                    <DialogDescription>{item.location}</DialogDescription>
                  </DialogHeader>
                  <div className="relative w-full h-[70vh] md:h-[85vh] bg-muted">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain grayscale" />
                    <div className="absolute bottom-0 left-0 right-0 p-6 bg-background/95 backdrop-blur-md border-t-2 border-border flex flex-col md:flex-row justify-between items-start md:items-center gap-2">
                      <span className="text-xl font-bold uppercase tracking-tight">
                        {item.title}
                      </span>
                      <span className="font-mono text-sm text-muted-foreground uppercase tracking-widest">
                        {item.location}
                      </span>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}